export { default } from "./client-navigation";
